// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"call-to-action-module--callToAction--3NnOk","link":"call-to-action-module--link--UcrEW","callToActionMarker":"call-to-action-module--callToActionMarker--2hOXE"};